export default function($) {

	var $backToTop = $('.c-back-to-top');

	$(window).on('scroll', function() {
	  if ($(this).scrollTop() < 150) {
	    $backToTop.fadeOut();
	  } else {
	    $backToTop.fadeIn();
	  }
	});

}
